export enum DisplaySaving {
  TwentyPercentSavings = 'Save 20% per oz',
}

/**
 * @deprecated
 * This is a temporary solution to get the product info for the add-ons.
 * For longer term, we want to serve this info from the backend.
 * See https://app.shortcut.com/farmersdog/story/136915/
 */
export enum AddonSku {
  ChickenSnapsLarge = 'SNAPS_CHICKEN_L',
  ChickenSnapsRegular = 'SNAPS_CHICKEN_M',
  ChickenSnapsV2Large = 'SNPS_CHKNV2_L',
  ChickenSnapsV2Regular = 'SNPS_CHKNV2_M',
  PorkSnapsLarge = 'SNPPOPE08000',
  PorkSnapsRegular = 'SNPPOPE03000',
  TurkeySnapsLarge = 'SNAPS_TURKEY_L',
  TurkeySnapsRegular = 'SNAPS_TURKEY_M',
  TurkeySnapsV2Large = 'SNPTKPE08000',
  TurkeySnapsV2Regular = 'SNPTKPE03000',
  ChewsLonger = 'TENBFLG08000',
  ChewsShorter = 'TENBFMD08000',
}

/**
 * @deprecated
 * This is a temporary solution to get the product info for the add-ons.
 * For longer term, we want to serve this info from the backend.
 * See https://app.shortcut.com/farmersdog/story/136915/
 */
export enum SnapSticksRecipeDisplayName {
  Chicken = 'Chicken Snap Sticks',
  Pork = 'Pork Snap Sticks',
  Turkey = 'Turkey Snap Sticks',
}

/**
 * @deprecated
 * This is a temporary solution to get the product info for the add-ons.
 * For longer term, we want to serve this info from the backend.
 * See https://app.shortcut.com/farmersdog/story/136915/
 */
export enum ChewsDislayName {
  ChewsLonger = 'Chews Longer',
  ChewsShorter = 'Chews Shorter',
}

/**
 * @deprecated
 * This is a temporary solution to get the product info for the add-ons.
 * For longer term, we want to serve this info from the backend.
 * See https://app.shortcut.com/farmersdog/story/136915/
 */
export enum TreatPackageSize {
  Regular = 'Regular',
  Large = 'Large',
}

const CHEW_LENGTH_QUERY_PARAM = 'length';
export const ChewQueryParams = {
  chewLength: CHEW_LENGTH_QUERY_PARAM,
};

/**
 * @deprecated
 * This is a temporary solution to get the product info for the add-ons.
 * For longer term, we want to serve this info from the backend.
 * See https://app.shortcut.com/farmersdog/story/136915/
 */
export interface AddonContent {
  /** The addon's sku */
  sku: AddonSku;
  /** What is the size of the addon packaging */
  packageSize?: TreatPackageSize;
  /** Treat recipe (display name) */
  recipeDisplayName: SnapSticksRecipeDisplayName | ChewsDislayName;
}

const chickenSnapsRegular: AddonContent = {
  sku: AddonSku.ChickenSnapsRegular,
  recipeDisplayName: SnapSticksRecipeDisplayName.Chicken,
  packageSize: TreatPackageSize.Regular,
};

const chickenSnapsLarge: AddonContent = {
  ...chickenSnapsRegular,
  sku: AddonSku.ChickenSnapsLarge,
  packageSize: TreatPackageSize.Large,
};

const chickenSnapsV2Regular: AddonContent = {
  sku: AddonSku.ChickenSnapsV2Regular,
  recipeDisplayName: SnapSticksRecipeDisplayName.Chicken,
  packageSize: TreatPackageSize.Regular,
};

const chickenSnapsV2Large: AddonContent = {
  ...chickenSnapsRegular,
  sku: AddonSku.ChickenSnapsV2Large,
  packageSize: TreatPackageSize.Large,
};

const porkSnapsRegular: AddonContent = {
  sku: AddonSku.PorkSnapsRegular,
  packageSize: TreatPackageSize.Regular,
  recipeDisplayName: SnapSticksRecipeDisplayName.Pork,
};

const porkSnapsLarge: AddonContent = {
  ...porkSnapsRegular,
  sku: AddonSku.PorkSnapsLarge,
  packageSize: TreatPackageSize.Large,
};

const turkeySnapsRegular: AddonContent = {
  sku: AddonSku.TurkeySnapsRegular,
  packageSize: TreatPackageSize.Regular,
  recipeDisplayName: SnapSticksRecipeDisplayName.Turkey,
};

const turkeySnapsLarge: AddonContent = {
  ...turkeySnapsRegular,
  sku: AddonSku.TurkeySnapsLarge,
  packageSize: TreatPackageSize.Large,
};

const turkeySnapsV2Regular: AddonContent = {
  sku: AddonSku.TurkeySnapsV2Regular,
  packageSize: TreatPackageSize.Regular,
  recipeDisplayName: SnapSticksRecipeDisplayName.Turkey,
};

const turkeySnapsV2Large: AddonContent = {
  ...turkeySnapsRegular,
  sku: AddonSku.TurkeySnapsV2Large,
  packageSize: TreatPackageSize.Large,
};

const chewsLonger: AddonContent = {
  sku: AddonSku.ChewsLonger,
  recipeDisplayName: ChewsDislayName.ChewsLonger,
};

const chewsShorter: AddonContent = {
  sku: AddonSku.ChewsShorter,
  recipeDisplayName: ChewsDislayName.ChewsShorter,
};

/**
 * @deprecated
 * This is a temporary solution to get the product info for the add-ons.
 * For longer term, we want to serve this info from the backend.
 * See https://app.shortcut.com/farmersdog/story/136915/
 */
export type AddonsContent = Record<AddonSku, AddonContent>;

/**
 * @deprecated
 * This is a temporary solution to get the product info for the add-ons.
 * For longer term, we want to serve this info from the backend.
 * See https://app.shortcut.com/farmersdog/story/136915/
 */
export const AddonsProductInfo: AddonsContent = {
  [AddonSku.ChickenSnapsLarge]: chickenSnapsLarge,
  [AddonSku.ChickenSnapsRegular]: chickenSnapsRegular,
  [AddonSku.ChickenSnapsV2Large]: chickenSnapsV2Large,
  [AddonSku.ChickenSnapsV2Regular]: chickenSnapsV2Regular,
  [AddonSku.PorkSnapsLarge]: porkSnapsLarge,
  [AddonSku.PorkSnapsRegular]: porkSnapsRegular,
  [AddonSku.TurkeySnapsLarge]: turkeySnapsLarge,
  [AddonSku.TurkeySnapsRegular]: turkeySnapsRegular,
  [AddonSku.TurkeySnapsV2Large]: turkeySnapsV2Large,
  [AddonSku.TurkeySnapsV2Regular]: turkeySnapsV2Regular,
  [AddonSku.ChewsLonger]: chewsLonger,
  [AddonSku.ChewsShorter]: chewsShorter,
};
